
import { defineComponent, SetupContext, PropType, computed } from "vue";
import NativeClient from "@/client/native-client";
import {
  RequestRecognitionCandidateItem
} from "@/types/pantry";

export default defineComponent({
  name: "PantryCameraCheckBottomView",
  components: {
  },
  props: {
    selectPosition: {
      type: Number,
      default: 0,
      required: true
    },
    foodList: {
      type: Array as PropType<RequestRecognitionCandidateItem[]>,
      default: [],
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const getPosition = () => {
      const size = (props.foodList && props.foodList.length >= 1) ? props.foodList.length : "1";
      return "" + (props.selectPosition + 1) + "/" + size;
    };
    const clickBack = () => {
      context.emit("click-back");
    };
    const clickSkip = () => {
      context.emit("click-skip");
    };
    // 表示／非表示制御
    const styleBackButton = computed(() => {
      let result = false;
      if (props.foodList.length > 1) {
        result = true;
        if (props.selectPosition == 0) {
          result = false;
        }
      }
      NativeClient.sendDebugLog(
        "PantryCameraCheckBottomView styleCancelButton selectPosition=" + JSON.stringify(props.selectPosition) + " result=" + result
      );
      if (result) {
        return { visibility: `visible` };
      } else {
        return { visibility: `hidden` };
      }
    });
    return {
      getPosition,
      clickBack,
      clickSkip,
      styleBackButton
    };
  }
});
